class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(".product-tabs__button");
    this.contents = this.querySelectorAll(".product-tabs__product-content");

    this.buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.dataset.id;

        this.buttons.forEach((b) =>
          b.classList.remove("product-tabs__button--active")
        );

        btn.classList.add("product-tabs__button--active");

        this.contents.forEach((c) =>
          c.classList.remove("product-tabs__product-content--active")
        );

        const activeContent = this.querySelector(
          `.product-tabs__product-content[data-id="${id}"]`
        );
        if (activeContent) {
          activeContent.classList.add("product-tabs__product-content--active");
        }
      });
    });
  }
}

customElements.define("product-tabs", ProductTabs);
